import React from "react";
import { Button, ArrowLeftIcon, ArrowRightIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const TextBtnWithIcons = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Text button with start and end icon"}
        value={
          '<Button variant={"text"} startIcon={<ArrowLeftIcon />} endIcon={<ArrowRightIcon />}>\n' +
          "            Label\n" +
          "          </Button>"
        }
      >
        <Button
          variant={"text"}
          startIcon={<ArrowLeftIcon />}
          endIcon={<ArrowRightIcon />}
        >
          Label
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default TextBtnWithIcons;
